<template>
    <cadastro-simples-form
        endpoint="situacao-familiar"
        rota-base="/admin/situacao-familiar"
        titulo-singular="Situação Familiar"
        :campos-extras='[]'>
    </cadastro-simples-form>
</template>

<script>
import CadastroSimplesForm from '@/components/cadastros-auxiliares/cadastro-simples-form.vue'
export default { components: { CadastroSimplesForm } }
</script>
